import { StoreState } from "../../../store/store.interface";

//search v2 selector
export const selectSearchV2Reasults = (state: StoreState) => state.searchV2State.search?.data?.hits;
export const selectV2Request = (state: StoreState) => state.searchV2State.search?.request;
export const isSuccess = (state: StoreState) => state.searchV2State.search?.isSuccess;
export const selectTotalForPagination = (state: StoreState) => {
    const pageLength = state.searchV2State.search?.request?.pageLength || 10
    const total = state.searchV2State.search?.data?.page.totalDocuments || 0;
    return (total > 100 * pageLength) ? (100 * pageLength) : total;
};
export const selectTotal = (state: StoreState) => state.searchV2State.search?.data?.page.totalDocuments || 0;
export const isLoading = (state: StoreState) => state.searchV2State.search?.isLoading;
export const isLoaded = (state: StoreState) => state.searchV2State.search?.isLoaded;
export const isFailure = (state: StoreState) => state.searchV2State.search?.isFailure;
export const searchParam = (state: StoreState) => state.searchV2State.search?.request?.searchTerms;

export const selectFacets = (state: StoreState) => {
    let isFacetValuePresent = false;
    const facets = state.searchV2State.search?.data?.facets || [];
    isFacetValuePresent = facets?.length > 0 && !!facets.find(facet => facet?.facetValues?.length > 0);
    return isFacetValuePresent ? facets : [];
};

export const selectedFacetCount = (state: StoreState) => {
    const facets = state.searchV2State.search?.request?.fieldValueFilter || {};
    const facetCount = Object.keys(facets).reduce((count: number, key: string) => {
        if (facets[key] && facets[key].length > 0) count += facets[key].length;
        return count;
    }, 0);
    return facetCount;
};

export const selectRequestFacetValues = (state: StoreState, facetName: string) => {
    return state.searchV2State.search?.request?.fieldValueFilter?.[facetName]
}

export const selectFacetLabels = (state: StoreState) => state.searchV2State.facetLabels;